import { type ColorProps, chakra } from '@chakra-ui/react'
import React from 'react'

import logger from '@/utils/logger'

import isSerializedRichTextProbably from '@/client/services/richText/isSerializedRichTextProbably'

import RichText from '../RichTextEditor/RichText'
import type { FormContent, FormValue } from './types'

export default function FormContentBlock({
  content,
  defaultTextColor = 'fg',
  isError = false,
}: {
  content: FormContent | FormValue
  defaultTextColor?: ColorProps['color']
  isError?: boolean
}): React.ReactElement | string | null {
  const textColor = isError ? 'fg.error' : defaultTextColor

  if (isSerializedRichTextProbably(content)) {
    return <RichText content={content} styleProps={{ color: textColor }} />
  }
  if (typeof content === 'string' || typeof content === 'number' || typeof content === 'boolean') {
    return <chakra.span color={textColor}>{content}</chakra.span>
  }
  if (React.isValidElement(content)) {
    return content
  }
  if (content == null) {
    return null
  }
  if (content instanceof Date) {
    return <chakra.span color={textColor}>{content.toISOString()}</chakra.span>
  }
  if (Array.isArray(content)) {
    return <chakra.span color={textColor}>{JSON.stringify(content)}</chakra.span>
  }

  logger.error('FormContentBlock: unknown content type', { content })
  return <>(An error occurred while rendering this portion)</>
}
